module.exports = __webpack_public_path__ + "img/7.60063ca7.png";